import { render, staticRenderFns } from "./ReferenceCard.vue?vue&type=template&id=1e7ec712&scoped=true"
import script from "./ReferenceCard.vue?vue&type=script&lang=js"
export * from "./ReferenceCard.vue?vue&type=script&lang=js"
import style0 from "./ReferenceCard.vue?vue&type=style&index=0&id=1e7ec712&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7ec712",
  null
  
)

export default component.exports